import React from 'react';

/** Numbered section chrome for the walk-in registration long form. */
export default function WalkinSection({
  step, title, hint, children, accent = '#F15A22', testId,
}) {
  return (
    <section
      className="rounded-2xl border border-[#D5DEE8] bg-white overflow-hidden shadow-sm"
      data-testid={testId}
    >
      <div className="flex items-start gap-3 px-4 py-3.5 border-b border-[#E8EEF5]"
        style={{ background: 'linear-gradient(90deg, #F8FAFC 0%, #fff 70%)' }}>
        <div
          className="h-8 w-8 rounded-xl flex items-center justify-center text-sm font-extrabold text-white shrink-0"
          style={{ background: `linear-gradient(145deg, ${accent}, #9a3412)` }}
        >
          {step}
        </div>
        <div className="min-w-0 pt-0.5">
          <h3 className="font-heading text-base text-[#071B34] leading-tight">{title}</h3>
          {hint ? <p className="text-[12px] text-[#5A6B7C] mt-0.5 leading-snug">{hint}</p> : null}
        </div>
      </div>
      <div className="p-4 sm:p-5 space-y-3">{children}</div>
    </section>
  );
}
